import { defineMessages } from 'react-intl';

type MessageKeys =
	| 'exportToPageButton'
	| 'publishPageButton'
	| 'spaceSelectorLabel'
	| 'pageTitlePlaceholder'
	| 'pageTitleLabel'
	| 'editPageNameButtonLabel';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		exportToPageButton: {
			id: 'ai-mate.message-actions.deep-research-actions.export-to-page-button',
			defaultMessage: 'Export to page',
			description:
				'Button label displayed on a button in the deep research results action card within the AI conversation interface that allows users to export the research results to a Confluence page. Shown as the text on a button. When clicked, it opens a dialog or form where users can configure and create a Confluence page from the research results. The purpose is to provide users with a way to save and share the deep research results as a Confluence page.',
		},
		publishPageButton: {
			id: 'ai-mate.message-actions.deep-research-actions.publish-page-button',
			defaultMessage: 'Publish page',
			description:
				'Button label displayed on the primary action button in the deep research export to page dialog within the AI conversation interface. Shown as the text on a button. When clicked, it creates and publishes a Confluence page containing the deep research results to the selected space. The purpose is to provide a clear call-to-action for users to confirm and execute publishing the research results as a Confluence page.',
		},
		spaceSelectorLabel: {
			id: 'ai-mate.message-actions.deep-research-actions.space-selector-label',
			defaultMessage: 'Space',
			description:
				'Label text displayed above or next to a space selector dropdown in the deep research export to page dialog within the AI conversation interface. Shown as a form field label. The purpose is to identify the space selector control, which allows users to choose which Confluence space the research results page will be published to.',
		},
		pageTitlePlaceholder: {
			id: 'ai-mate.message-actions.deep-research-actions.page-title-placeholder',
			defaultMessage: 'Write your page title here',
			description:
				'Placeholder text displayed in a text input field for the page title in the deep research export to page dialog within the AI conversation interface. Shown as placeholder text when the input field is empty. The purpose is to guide users on what they should enter in the page title input field, prompting them to enter a title for the Confluence page that will contain the research results.',
		},
		pageTitleLabel: {
			id: 'ai-mate.message-actions.deep-research-actions.page-title-label',
			defaultMessage: 'Page name',
			description:
				'Accessible label for the page title inline edit text field in the deep research export to page dialog within the AI conversation interface. Used by screen readers to announce the purpose of the input field.',
		},
		editPageNameButtonLabel: {
			id: 'ai-mate.message-actions.deep-research-actions.edit-page-name-button-label',
			defaultMessage: 'Edit page name',
			description:
				'Accessible label for the edit button in the page name inline edit field in the deep research export to page dialog. Screen readers will announce this when a user focuses the edit trigger button. Replaces the default non-descriptive "Edit, edit" label.',
		},
	});

export default message;
